import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../utils/helpers/model.helper';

export const USER_SCHEMA = Object.freeze({
  USER_ID: '',
  NAME: null, // ''
  EMAIL: '',
  PHONE_NUMBER: null,
  IS_EMAIL_HARD_BOUNCED: false,
});
const RECORD = generateSchema(USER_SCHEMA);
const KEYS: any = generateKeys(USER_SCHEMA);

export class User extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get userId(): string {
    return this.get(KEYS.USER_ID);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get phoneNumber(): string {
    return this.get(KEYS.PHONE_NUMBER);
  }

  get isEmailHardBounced(): boolean {
    return this.get(KEYS.IS_EMAIL_HARD_BOUNCED);
  }
}
